var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useCallback } from "react";
import classNames from "classnames";
import { Button } from "../Button";
// styles
import "./valuePicker.scss";
// use the optional prop interface to define the default props
const defaultProps = {
    "data-testid": "tecma-valuePicker",
    leftIcon: "arrow-left",
    rightIcon: "arrow-right",
    outlined: false,
};
const ValuePicker = (_a) => {
    var { options, value, leftIcon, rightIcon, onPrevClick, onNextClick, onChange, outlined, className, loop, placeholder } = _a, rest = __rest(_a, ["options", "value", "leftIcon", "rightIcon", "onPrevClick", "onNextClick", "onChange", "outlined", "className", "loop", "placeholder"]);
    const classList = classNames("tecma-valuePicker", { outlined }, className);
    const shouldShowPlaceholder = placeholder && value === null;
    const classListContainer = classNames("valuePicker-container", {
        disabled: shouldShowPlaceholder,
    });
    const selectedValueIndex = options.findIndex((option) => option.value === value);
    const getTranslateValue = useCallback((itemIndex) => -(selectedValueIndex - itemIndex) * 100, [selectedValueIndex]);
    const handleNextClick = useCallback(() => {
        var _a;
        const nextIndex = loop
            ? (selectedValueIndex + 1) % options.length
            : Math.min(options.length - 1, selectedValueIndex + 1);
        if (onNextClick) {
            onNextClick();
        }
        onChange((_a = options[nextIndex]) === null || _a === void 0 ? void 0 : _a.value);
    }, [loop, onChange, onNextClick, options, selectedValueIndex]);
    const handlePrevClick = useCallback(() => {
        var _a;
        const nextIndex = loop
            ? ((selectedValueIndex < 0 ? 0 : selectedValueIndex) + options.length - 1) % options.length
            : Math.max(0, selectedValueIndex - 1);
        if (onPrevClick) {
            onPrevClick();
        }
        onChange((_a = options[nextIndex]) === null || _a === void 0 ? void 0 : _a.value);
    }, [loop, onChange, onPrevClick, options, selectedValueIndex]);
    return (_jsxs("div", Object.assign({ className: classList }, rest, { children: [_jsx(Button, { className: "prev-button", iconName: leftIcon, onClick: handlePrevClick, outlined: outlined, size: "large", disabled: !loop && selectedValueIndex <= 0 }), _jsxs("div", { className: classListContainer, children: [placeholder && (_jsx("p", { style: {
                            transform: `translateX(${getTranslateValue(shouldShowPlaceholder ? selectedValueIndex : selectedValueIndex - 1)}%)`,
                        }, children: placeholder })), options.map(({ value: curValue, label }, index) => {
                        return (_jsx("p", { style: { transform: `translateX(${getTranslateValue(index)}%)` }, children: label }, curValue));
                    })] }), _jsx(Button, { className: "next-button", iconName: rightIcon, onClick: handleNextClick, outlined: outlined, size: "large", disabled: !loop && selectedValueIndex === options.length - 1 })] })));
};
ValuePicker.defaultProps = defaultProps;
export default React.memo(ValuePicker);
